import { render, staticRenderFns } from "./login-role-select.vue?vue&type=template&id=543385b0&scoped=true&"
import script from "./login-role-select.vue?vue&type=script&lang=js&"
export * from "./login-role-select.vue?vue&type=script&lang=js&"
import style0 from "./login-role-select.vue?vue&type=style&index=0&id=543385b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543385b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCardTitle,VImg,VSheet})
